import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { AssetGroupModel, useListAssetGroupsQuery } from '@casops/store/apis/assetGroupsApi';
import { useMemo } from 'react';

export const useAssetGroupOptions = (): DropdownItemProps<number>[] => {
  const { data: assetGroups } = useListAssetGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  return useMemo<DropdownItemProps<number>[]>(() => {
    if (typeof assetGroups !== 'undefined') {
      return assetGroups.map(({ id, name }: AssetGroupModel) => ({
        key: id.toString(),
        value: id,
        stringValue: name,
        label: name,
      }));
    }
    return [];
  }, [assetGroups]);
};

export default useAssetGroupOptions;
